export default __webpack_public_path__ + "static/media/favicon.a391f095.ico";